import { Abbr } from "@site/src/components";

export default function ThirdPersPlural() {
  return (
    <table
      className="table_sticky"
    >
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th />
          <th><Abbr>nom.</Abbr></th>
          <th><Abbr>acc.</Abbr></th>
          <th><Abbr>gen.</Abbr></th>
          <th><Abbr>dat.</Abbr></th>
          <th><Abbr>ins.</Abbr></th>
          <th><Abbr>loc.</Abbr></th>
        </tr>
        <tr>
          <th>OCS</th>
          <td>
            ji/ję/ja
            <br />
            [oni/ony/ona]
          </td>
          <td>ji/ję/ja</td>
          <td>jixъ</td>
          <td>jimъ</td>
          <td>jimi</td>
          <td>jixъ</td>
        </tr>
        <tr>
          <th>Russian</th>
          <td> oní </td>
          <td>ix </td>
          <td>ix </td>
          <td>im </td>
          <td>imi </td>
          <td>nix</td>
        </tr>
        <tr>
          <th>Belarussian</th>
          <td> janý </td>
          <td>ix </td>
          <td>ix </td>
          <td>im </td>
          <td>ími </td>
          <td>ix</td>
        </tr>
        <tr>
          <th>Ukrainian</th>
          <td> voný </td>
          <td>jix </td>
          <td>jix </td>
          <td>jim </td>
          <td>jimy </td>
          <td>jix</td>
        </tr>
        <tr>
          <th>Lemko-Rusyn</th>
          <td> ony </td>
          <td>ix </td>
          <td>im </td>
          <td>ix </td>
          <td>nyma </td>
          <td>nyx</td>
        </tr>
        <tr>
          <th>Polish</th>
          <td> oni/one </td>
          <td>ich/je</td>
          <td>ich </td>
          <td>im </td>
          <td>nimi </td>
          <td>nich</td>
        </tr>
        <tr>
          <th>Cashubian</th>
          <td> oni/ni,<br />onë/në</td>
          <td>jich/je</td>
          <td>jich/jejich</td>
          <td>jim/jima</td>
          <td>nimi/<br />jima/<br />nima</td>
          <td>nich</td>
        </tr>
        <tr>
          <th>Lower Sorbian</th>
          <td> woni </td>
          <td>jich/je</td>
          <td>jich </td>
          <td>jim </td>
          <td>nimi </td>
          <td>nich</td>
        </tr>
        <tr>
          <th>Upper Sorbian</th>
          <td> woni/wone </td>
          <td>jich/je</td>
          <td>jich </td>
          <td>jim </td>
          <td>nimi </td>
          <td>nich/nimi</td>
        </tr>
        <tr>
          <th>Czech</th>
          <td>oni/ony/ona</td>
          <td>je </td>
          <td>jich </td>
          <td>jim </td>
          <td>jimi </td>
          <td>nich</td>
        </tr>
        <tr>
          <th>Slovak</th>
          <td> oni/ony </td>
          <td>ich/ne </td>
          <td>ich </td>
          <td>im </td>
          <td>nimi </td>
          <td>nich</td>
        </tr>
        <tr>
          <th>Slovene</th>
          <td> oni/one/ona </td>
          <td>njih </td>
          <td>njih </td>
          <td>njim </td>
          <td>njimi </td>
          <td>njih</td>
        </tr>
        <tr>
          <th>Serbian/Croatian</th>
          <td> òni/òne/òna </td>
          <td>njîh/ih</td>
          <td>njîh/ih </td>
          <td>njìma/im</td>
          <td>njìma </td>
          <td>njìma</td>
        </tr>
        <tr>
          <th>Macedonian</th>
          <td> tie </td>
          <td>niv/gi </td>
          <td>— </td>
          <td>nim/im</td>
          <td>— </td>
          <td>—</td>
        </tr>
        <tr>
          <th>Bulgarian</th>
          <td> te </td>
          <td>tjax/gi</td>
          <td>— </td>
          <td>im/tjam </td>
          <td>— </td>
          <td>—</td>
        </tr>
        <tr>
          <th>Interslavic</th>
          <td>
            <b>oni/one</b>
          </td>
          <td>
            <b>(n)jih/<br />(n)je</b>
          </td>
          <td>
            <b>(n)jih</b>
          </td>
          <td>
            <b>(n)jim</b>
          </td>
          <td>
            <b>(n)jimi</b>
          </td>
          <td>
            <b>(n)jih</b>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
